/** Instrument + skill level options for the in-app "Set your dashboard" survey. */

export type HomeSurveyInstrumentId =
  | "piano"
  | "guitar"
  | "bass"
  | "drums"
  | "vocals"
  | "saxophone"
  | "trumpet"
  | "vibraphone";

export type HomeSurveyLevelId = "beginner" | "intermediate" | "advanced";

export const HOME_SURVEY_INSTRUMENTS: {
  id: HomeSurveyInstrumentId;
  label: string;
}[] = [
  { id: "piano", label: "Piano" },
  { id: "guitar", label: "Guitar" },
  { id: "bass", label: "Bass" },
  { id: "drums", label: "Drums" },
  { id: "vocals", label: "Vocals" },
  { id: "saxophone", label: "Saxophone" },
  { id: "trumpet", label: "Trumpet" },
  { id: "vibraphone", label: "Vibraphone" },
];

export const HOME_SURVEY_LEVELS: {
  id: HomeSurveyLevelId;
  label: string;
  description: string;
}[] = [
  {
    id: "beginner",
    label: "Beginner",
    description:
      "You can play the instrument at a basic level but you're just getting started with jazz.",
  },
  {
    id: "intermediate",
    label: "Intermediate",
    description:
      "You've got the basics, now you want to build your repertoire and confidence on the bandstand.",
  },
  {
    id: "advanced",
    label: "Advanced",
    description:
      "You're a high-level performer focused on expanding your harmonic palette, complex tunes, and personal expression.",
  },
];
